import { Outlet } from 'react-router';

import { Suspense } from '@sorare/core/src/atoms/Suspense';
import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

const MLBLayout = () => {
  return (
    <Suspense fallback={<LoadingIndicator fullHeight />}>
      <AppLayout>
        <Outlet />
      </AppLayout>
    </Suspense>
  );
};
export default MLBLayout;
